import { useEffect } from "react";
import "./loader.css";

const Loader = ({ type }) => {
    const renderLoader = () => {
        switch (type) {
            case 'default':
                return <span class="loader"></span> // Implementa il tuo spinner
            case 'quest':
                return <span class="quest-loader"></span> // Implementa il tuo triangolo
            case 'loader':
            default:
                return <span class="loader"></span>; // Implementa il tuo loader predefinito
        }
    };

  return (
    <div class="loading-state">
        {renderLoader()}
    </div>
   
  );
};

export default Loader;
